import { lazy, Suspense, useEffect, useState } from "react";

const FloatingTerminal = lazy(() =>
  import("./FloatingTerminal").then((m) => ({ default: m.FloatingTerminal }))
);

export function LazyFloatingTerminal() {
  const [hasTriggered, setHasTriggered] = useState(
    () => sessionStorage.getItem("terminal.isOpen") === "true"
  );

  useEffect(() => {
    if (hasTriggered) return;
    const onKey = (e: KeyboardEvent) => {
      if (e.key?.toLowerCase() === "j" && (e.metaKey || e.ctrlKey)) {
        e.preventDefault();
        sessionStorage.setItem("terminal.isOpen", "true");
        setHasTriggered(true);
      }
    };
    document.addEventListener("keydown", onKey);
    return () => document.removeEventListener("keydown", onKey);
  }, [hasTriggered]);

  if (!hasTriggered) return null;

  return (
    <Suspense fallback={null}>
      <FloatingTerminal />
    </Suspense>
  );
}
